import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from '../41e3e4ef74b344163f6f9c634823f771533dce8ee2dfa33ad6af214c7fd67517.cfe-internal.js';
import { useInputGroupContext } from '../../InputGroup/cd290dc9875526bf8b4a87c532dd848f47a3d87c6c746e77ffaa6cdb173c3440.cfe-internal.js';
import { useFormFieldControl } from '../../FormField/ff8bdfb918b98e400d01f1272050447aed13a9c7dbe824884d42b110edddae42.cfe-internal.js';
import concatIds from '../../../utils/concatIds/4f58d37595ecc5912f64ecb84828b103f66a43e895e850434f09170560f4b3d7.cfe-internal.js';
import ChevronDownIcon from '../../../icons/components/4c975a209dca1acd161483651b12be72e314db89e3e5feaea7249f21ff171db0.cfe-internal.js';

var _excluded = ["label", "className", "small", "isOpen", "disabled", "style", "onClick", "onKeyDown", "aria-describedby"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context, _context2; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(source), !0)).call(_context, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var MenuAnchor = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _classNames, _classNames2;

  var label = _ref.label,
      className = _ref.className,
      small = _ref.small,
      isOpen = _ref.isOpen,
      disabled = _ref.disabled,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      externalAriaDescribedBy = _ref['aria-describedby'],
      rest = _objectWithoutProperties(_ref, _excluded);

  var inputGroupContext = useInputGroupContext();

  var _useFormFieldControl = useFormFieldControl(),
      hasFormLabel = _useFormFieldControl.hasLabel,
      formFieldHelperTextId = _useFormFieldControl.helperTextId,
      formFieldErrorTextId = _useFormFieldControl.errorTextId;

  var internalAriaDescribedby = concatIds(externalAriaDescribedBy, formFieldHelperTextId, formFieldErrorTextId);
  return /*#__PURE__*/React__default.createElement("button", _extends({}, rest, {
    ref: ref,
    type: "button",
    className: classNames(className, styles.menuBtn, inputGroupContext.className, (_classNames = {}, _defineProperty(_classNames, styles.unlabelledButton, !label && label !== 0), _defineProperty(_classNames, styles.small, inputGroupContext.applySmall(small)), _defineProperty(_classNames, styles.formLabelled, hasFormLabel), _classNames)),
    "aria-haspopup": "menu",
    "aria-disabled": disabled,
    "aria-describedby": internalAriaDescribedby,
    style: _objectSpread({
      display: typeof label === 'string' ? 'inline-block' : undefined
    }, style),
    onClick: disabled ? undefined : onClick,
    onKeyDown: disabled ? undefined : onKeyDown
  }), label, /*#__PURE__*/React__default.createElement(ChevronDownIcon, {
    className: classNames(styles.rightIcon, (_classNames2 = {}, _defineProperty(_classNames2, styles.small, inputGroupContext.applySmall(small)), _defineProperty(_classNames2, styles.open, isOpen), _classNames2)),
    "aria-hidden": "true"
  }));
});
var MenuAnchor$1 = MenuAnchor;

export { MenuAnchor$1 as default };
